import type { ReactNode } from 'react';

import './demographicItem.scss';

type Props = {
  label: string;
  children: ReactNode;
};

export function DemographicItem({ label, children }: Props) {
  return (
    <div className="demographicItem">
      <span className="demographicItem__label">{label}</span>
      <p className="demographicItem__value">{children}</p>
    </div>
  );
}
